export const navConfig = [
  {
    key: 'Main',
    links: [
      {
        key: 1,
        name: 'Home',
        href: '/',
        icon: 'Home',
        exact: true,
      },
      {
        key: 2,
        name: 'Data Owners',
        href: '/dataOwners',
        icon: 'PublishContent',
      },
      {
        key: 3,
        name: 'Consumers',
        href: '/consumers',
        icon: 'Subscribe',
      },
      {
        key: 5,
        name: 'Machine learning',
        href: '/machine-learning',
        icon: 'TestBeakerSolid',
      },
    ],
  },
];

export const adminNavConfig = [
  {
    key: 'Main',
    links: [
      {
        key: 1,
        name: 'Home',
        href: '/',
        icon: 'Home',
        exact: true,
      },
      {
        key: 2,
        name: 'Data Owners',
        href: '/dataOwners',
        icon: 'PublishContent',
      },
      {
        key: 3,
        name: 'Consumers',
        href: '/consumers',
        icon: 'Subscribe',
      },
      {
        key: 5,
        name: 'Machine learning',
        href: '/machine-learning',
        icon: 'TestBeakerSolid',
      },
      {
        key: 6,
        name: 'Provisioning',
        href: '/provisioning',
        icon: 'Processing',
      },
    ],
  },
];
